// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V2SzWv6u66s7xPbtQcFm {
    position: relative;
    left: -24px;
}

.X8Z8t7JgzCqcJpSrUptF {
    display: flex;
    gap: 8px;
    position: relative;
    bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/AppointmentBookingHeader/HeaderDesktop/HeaderDesktop.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":[".desktopStepper {\n    position: relative;\n    left: -24px;\n}\n\n.buttonGroup {\n    display: flex;\n    gap: 8px;\n    position: relative;\n    bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"desktopStepper": `V2SzWv6u66s7xPbtQcFm`,
	"buttonGroup": `X8Z8t7JgzCqcJpSrUptF`
};
export default ___CSS_LOADER_EXPORT___;
